import { createSlice } from "@reduxjs/toolkit";
import { GrowthInfectionDefaultDataset } from "../data_model/growthInfecModel/post_growth_infection_model";

export const post_Growth_Stages = createSlice({
  name: "post_disease_type",
  initialState: {
    value: {
      status: false,
      langMap: GrowthInfectionDefaultDataset,
      defaultLangMap: GrowthInfectionDefaultDataset,
    },
  },
  reducers: {
    resetLangMap: (state, action) => {
      state.value.langMap = GrowthInfectionDefaultDataset;
    },
    //add empty language dataset
    addNewLangData: (state, action) => {
      state.value.status = true;
      const incomingPayload = action.payload;
      const newArray = [...state.value.langMap.langMap, incomingPayload];
      state.value.langMap.langMap = newArray;
    },
    //update individual items in localization array
    replaceIndex: (state, action) => {
      const newPayload = action.payload;
      const existingPayload = state.value.langMap?.langMap;
      const newUpdateData = existingPayload.map((item) =>
        item.langCode === newPayload.langCode ? newPayload : item
      );
      state.value.langMap.langMap = newUpdateData;
    },
  },
});

export const { resetLangMap, addNewLangData, replaceIndex } =
  post_Growth_Stages.actions;

export default post_Growth_Stages.reducer;
